// @flow
import { isMobile } from 'helpers/MediaHelper';
import { TIME_SECONDS } from 'components/Time';

export const apiToastDefaultOptions = {
    autoHideDuration: ((isMobile()
        ? 5 * TIME_SECONDS
        : 15 * TIME_SECONDS): number),
};
